// extracted by mini-css-extract-plugin
module.exports = {"container":"HourglassSpinner_container__luyxy","hourglass":"HourglassSpinner_hourglass__HHXxU","rotation":"HourglassSpinner_rotation__yY6W0"};